'use es6';

import { createSelector } from 'reselect';
import { getFocusedThreadDetails } from '../../thread-details/selectors/getFocusedThreadDetails';
import { getVid } from 'conversations-thread-data/thread-details/public/operators';
export const getFocusedThreadVisitorId = createSelector([getFocusedThreadDetails], getVid);